export default __webpack_public_path__ + "static/media/gamedesign_open.0bbd3b67.png";